<style lang="scss" scoped>
div {
  box-sizing: border-box;
}
.un-select {
  width: 36px;
  height: 36px;
  border: 2px solid #1d1d1d;
  background-color: #ffffff;
  border-radius: 50%;
}

.cannot-select {
  width: 36px;
  height: 36px;
  border: 2px solid #cdcdd4;
  background-color: #e7e7f0;
  border-radius: 50%;
}

.product-list-page {
  height: 100vh;
  padding-top: 230px;
  overflow: scroll;
  // background-image: url('https://oss.turingsenseai.com/1623912866964426136.png');
  background-size: 100% 100%;
  background-color: #F8F8FB;

  .search-container {
    // background-image: url('https://oss.turingsenseai.com/1623913475552458502.png');
    background-color: #ffffff;
    background-size: 100% 100%;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 999;
    height: 120px;
    .input-wrap {
      width: 702px;
      height: 72px;
      box-sizing: border-box;
      // border: 4px solid #000;
      border-radius: 4px;
      background-color: #F8F8FB;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 24px;
      margin: 24px auto;
      .search-input {
        flex: 1;
        margin-right: 20px;
        border: none;
        height: 64px;
        padding-left: 24px;
        background-color: #F8F8FB;
      }
      .search-icon {
        width: 36px;
        height: 36px;
        object-fit: contain;
      }
    }
  }
  .filter-container {
    height: 88px;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 24px;
    display: flex;
    background-color: #ffffff;
    position: fixed;
    top: 120px;
    z-index: 999;
    .common-item {
      font-size: 28px;
      color: #828393;
      margin-right: 60px;
    }
    .active {
      color: #5757FF;
    }

    .add-item {
      flex: 1;
      text-align: right;
    }
    .price {
      display: flex;
      align-items: center;
      display: flex;
      align-items: center;
    }
    .price-icon {
      height: 22px;
      width: 13px;
      margin-left: 10px;
    }

  }
  .split-line {
    position: fixed;
    top: 120px;
    height: 18px;
    width: 100%;
    // background-image: url('https://oss.turingsenseai.com/1623914645893707324.png');
    background-size: 100% 100%;
    z-index: 999;
  }

  .list-container {
    height: 100%;
  }

  .product-list {
    margin: 0 auto;
    width: 702px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    .product-item {
      margin-bottom: 18px;
      width: 344px;
      height: 530px;
      box-sizing: border-box;
      // border: 4px solid #000;
      border-radius: 4px;
      background-color: #fff;
      overflow: hidden;
      .product-img {
        width: 344px;
        height: 344px;
        overflow: hidden;
        position: relative;
        .img {
          width: 100%;
          height: 100%;
          object-fit: cover
        }
        .sold-out {
          width: 140px;
          height: 140px;
          background-color: rgba($color: #000000, $alpha: 0.7);
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translateX(-50%) translateY(-50%);
          color: #ffffff;
          font-size: 46px;
          border-radius: 50%;
        }
      }
      .add-cart-container {
        position: absolute;
        top: 22px;
        right: 24px;
        width: 36px;
        height: 36px;
      }
      .msg-container {
        padding: 12 * 2px;
        box-sizing: border-box;
        .product-name {
          height: 34 * 2px;
          font-size: 26px;
          line-height: 34px;
          color: #2a2a30;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          line-clamp: 2;
          -webkit-line-clamp: 2;
        }
        .price {
          margin-top: 32px;
          color: #FF5572;
          display: flex;
          .pre {
            font-size: 22px;
            line-height: 56px;
            margin-right: 4px;
          }
          .count {
            font-size: 34px;
            font-weight: 800;
          }
        }
      }
    }
  }

  .cart-container {
    height: 204px;
    width: 100%;
    padding-bottom: 68px;
    background-color: #ffffff;
    display: flex;
    justify-content: space-between;
    padding: 20px 24px;
    bottom: 0;
    position: fixed;
    
    .select-content {
      height: 96px;
      display: flex;
      align-items: center;
      justify-content: center;
      .select-icon {
        width: 36px;
        height: 36px;
      }
      .tips {
        margin-left: 24px;
        color: #2a2a30;
        font-size: 28px;
        font-weight: 500;
      }

    }
    .add-btn {
      width: 280px;
      height: 96px;
      background-color: #2a2a30;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #ffffff;
      font-size: 36px;
      font-weight: 500;
    }

  }
  .no-data-container {
    padding-top: 312px;
    text-align: center;
    width: 100%;
    .tips {
      font-size: 28px;
      // width: 100%;
      color: #2a2a30;
      text-align: center;
    }
  }
}
</style>

<template>
  <div class="product-list-page">
    <div class="search-container">
      <div class="input-wrap">
        <input type="text" placeholder="搜索商品" class="search-input" v-model="searchWords"/>
        <img class="search-icon" @click="getProductList(true)" src="https://oss.turingsenseai.com/1623826683071669972.png"/>
      </div>
    </div>
    <div class="filter-container">
      <div :class="` ${sortType == 0 ? 'active' : ''} common-item`" @click="setNewestSort">最新发布</div>
      <div :class="` ${isOnSell ? 'active' : ''} common-item`" @click="setIsOnSell">只看在售</div>
      <div :class="` ${(sortType == 1 || sortType == 2) ? 'active' : '' } common-item price`" @click="setPriceSort">价格
        <img v-if="sortType == 1" class="price-icon" src="https://oss.turingsenseai.com/1619506281773693006.png"/>
        <img v-else-if="sortType == 2" class="price-icon" src="https://oss.turingsenseai.com/1619506295362672905.png"/>
        <img v-else class="price-icon" src="https://oss.turingsenseai.com/1619505682355132227.png"/>
      </div>
      <div class="add-item active" @click="openAddCart">+ 批量加购</div>
    </div>
    <div class="split-line"></div>
    <van-pull-refresh v-if="dataList.length > 0" v-model="refreshing" @refresh="getProductList(true)">
      <van-list
        class="list-container"
        v-model="loadingMore"
        :finished="finished"
        finished-text="没有更多了"
        @load="getProductList(false)">
        <div class="product-list">
          <div class="product-item" v-for="(product, index) in dataList" :key="index" @click="goDetail(product.pid, index)">
            <div class="product-img">
              <img class="img" :src="product.appearancePic" alt="">
              <div class="sold-out" v-if="product.status == 2">售罄</div>
              <div v-if="addCartFlag" class="add-cart-container">
                <div v-if="product.status == 2" class="cannot-select"></div>
                <img v-else-if="product.selected" class="select-icon" src="https://oss.turingsenseai.com/1626766756639220820.png" />
                <div v-else class="un-select"></div>
              </div>
            </div>
            
            <div class="msg-container">
              <div class="product-name">{{product.productName}}</div>
              <div class="price">
                <div class="pre">￥</div>
                <div class="count">{{product.price / 100}}</div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <div v-else class="no-data-container">
      <div class="tips">暂无数据</div>
    </div>
    <div v-if="this.addCartFlag" class="cart-container">
      
      <div class="select-content" @click="selectAll">
        <img v-if="this.selectedAll" class="select-icon" src="https://oss.turingsenseai.com/1626766756639220820.png" />
        <div v-else class="un-select"></div>
        <div class="tips">全选</div>
      </div>
      <div class="add-btn" @click="addToCart">加入购物车</div>
    </div>
    <cart-float/>

  </div>
</template>

<script>
import { List, PullRefresh, Popup } from 'vant';
// import { fetchProductList } from '../../../common/api/bag-show'
import { fetchProductList, addToCart } from './../../../common/api/purchase';
import { Toast } from 'vant'
import  CartFloat from './../components/cart.vue'

// const priceGreyUrl = 'https://oss.turingsenseai.com/1619505682355132227.png'
// const priceUpUrl = 'https://oss.turingsenseai.com/1619506281773693006.png'
// const priceDownUrl = 'https://oss.turingsenseai.com/1619506295362672905.png'

export default {
  components: {
    'van-list': List,
    'van-pull-refresh': PullRefresh,
    'van-popup': Popup,
    'cart-float': CartFloat,
  },
  data() {
    return {
      loadingMore: false,
      finished: false,
      refreshing: false,
      pageNum: 0,
      pageSize: 20,
      searchWords: '',
      dataList: [],
      uid: '',
      loading: false,
      sortType: 0,  // 0最新发布， 1：价格升序 2： 价格降序
      isOnSell: false,  // 是否只查询在售
      addCartFlag: false, // 是否加入购物车
      selectedAll: false,
    }
  },
  created() {
    const { uid } = this.$route.params
    this.uid = uid
    this.getProductList(true)
  },
  methods: {
    getProductList(reset) {
      if (reset) {
        this.pageNum = 0
        this.finished = false;
      }
      if (this.finished || this.loading) return
      this.loading = true
      this.pageNum ++ ;
      fetchProductList({ pageNum: this.pageNum, pageSize: this.pageSize, uid: this.uid, productName: this.searchWords, sortBy: this.sortType, isOnSell: this.isOnSell })
        .then(res => {
          if (res && res.errorCode == 0) {
            this.dataList = reset ? res.productList : [...this.dataList, ...res.productList]
            this.finished = res.isEnd
            this.selectedAll = false
          }
        }).finally(() => {
          this.refreshing = false;
          this.loadingMore = false;
          this.loading = false
        })
    },
    search() {
      this.getProductList(true)
    },
    goDetail(pid, idx) {
      if (this.addCartFlag) {
        this.changeSelect(idx)
        return
      }

      this.$router.push({ path: `/purchase/product-detail/${pid}`})
    },
    setNewestSort() {
      if (this.sortType !== 0 ) {
        this.sortType = 0
        this.getProductList(true)
      }
    },
    setPriceSort() {
      if (this.sortType == 0) {
        this.sortType = 1
      } else if (this.sortType == 1) {
        this.sortType = 2
      } else {
        this.sortType = 1
      }
      this.getProductList(true)
    },
    setIsOnSell() {
      this.isOnSell = !this.isOnSell
      this.getProductList(true)
    },
    openAddCart() {
      this.addCartFlag = !this.addCartFlag
    },
    changeSelect(idx) {
      if (this.dataList[idx].status == 2) return
      this.dataList[idx] && (this.dataList[idx].selected = !this.dataList[idx].selected)
      this.dataList = [...this.dataList]
      console.log('zzzzzz', this.dataList)

    },
    // 全选或全不选
    selectAll() {
      this.selectedAll = !this.selectedAll
      this.dataList.forEach(item => {
        if (item.status != 2 ) {
          item.selected = this.selectedAll
        }
      })
    },
    addToCart() {
      const pidArr = this.dataList.filter(item => item.selected).map(item => {
        return item.pid
      })
      if (!pidArr || pidArr.length <= 0) {
        Toast.fail('未选择任何商品')
        return
      }
      this.addCartFlag = false
      addToCart({ pids: pidArr.join('-') })
        .then(res => {
          if (res && res.errorCode == 0) {
            Toast.success('加入购物车成功')
          }
        })
    }
  }
}
</script>